<template>
  <div class="min-h-screen">
    <div class="bg-gray-50">
      <slot></slot>
    </div>
  </div>
</template>
<script setup lang="ts"></script>
<style scoped></style>
